import classnames from 'classnames';
import './index.scss';

interface IBixCheckboxProps {
  checked?: boolean;
  id: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  forGrid?: boolean;
  title?: string;
  disabled?: boolean;
  postLabelRender?: React.ReactNode;
  children: React.ReactNode;
}

const BixCheckbox: React.FC<IBixCheckboxProps> = props => {
  const { checked, onChange, forGrid, title, disabled, postLabelRender } = props;
  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(e);
    }
  };
  return (
    <div className={classnames('bix_checkbox', { for_grid: forGrid })}>
      <div className="checkbox_wrap">
        <input
          type="checkbox"
          id={props.id}
          name={props.id}
          onChange={handleOnChange}
          checked={checked}
          disabled={disabled}
        />
        {props.children ? (
          <label htmlFor={props.id} title={title}>
            {props.children}
          </label>
        ) : (
          <label htmlFor={props.id} title={title} />
        )}
        {postLabelRender && <div>{postLabelRender}</div>}
      </div>
    </div>
  );
};

export default BixCheckbox;
